"use strict";

import { secureEmailConstants } from "../_constants";

const INITIAL_SECURE_EMAIL_STATE = {
  isNewMessageAvailable: null,
  replyMessage: null,
  attachement: null,

  isOtpRequired: null,
};

export function secureEmailReducer(state = INITIAL_SECURE_EMAIL_STATE, action) {
  switch (action.type) {
    case secureEmailConstants.SECURE_EMAIL_CLEAR_DATA: {
      return {
        saveDraft: null,

        showSuccessMessage: false,
      };
    }

    case secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_REQUEST: {
      return {
        ...state,
        isNewMessageAvailable: action.payload,
      };
    }
    case secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_COMPLETE: {
      return {
        ...state,
        isNewMessageAvailable:
          action.payload?.data?.isUnReadSecureMailMessageAvailable,
      };
    }
    case secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_ERROR: {
      return {
        ...state,
        isNewMessageAvailable: action.payload?.data,
      };
    }
    case secureEmailConstants.SECURE_MAIL_SINGLE_NOTIFY_ERROR: {
      return {
        ...state,
        isNewMessageAvailable: action.payload?.data,
      };
    }

    case secureEmailConstants.SECURE_MAIL_SEND_OTP_COMPLETE: {
      return {
        ...state,
        isOtpRequired: action.payload?.data?.isOtpRequired,
      };
    }
    case secureEmailConstants.SECURE_MAIL_SEND_OTP_ERROR: {
      return {
        ...state,
        isOtpRequired: null,
      };
    }
    case secureEmailConstants.SECURE_MAIL_RESEND_OTP_REQUEST: {
      return {
        ...state,
      };
    }

    case secureEmailConstants.SECURE_MAIL_RESEND_OTP_ERROR: {
      return {
        ...state,
      };
    }
  }

  return state;
}

const INITIAL_SECURE_MAIL_DRAFT = {
  draftInititalValues: {},
  saveDraft: null,
  isSavingDraft: false,
  showDraftSuccessMessage: false,
  showSentSuccessMessage: false,
  mailInitiateDetails: {},
  sentMailDetails: {},
  uploadedAttachments: [],
  uploadingAttachments: [],
  sendError: false,
};

export function secureMailDraftReducer(
  state = INITIAL_SECURE_MAIL_DRAFT,
  action,
) {
  switch (action.type) {
    case secureEmailConstants.SECURE_EMAIL_SAVE_TO_DRAFT_REQUEST:
      return {
        ...state,
        mailInitiateDetails: {},
        showDraftSuccessMessage: false,
        showSentSuccessMessage: false,
        isSavingDraft: true,
      };
    case secureEmailConstants.SECURE_EMAIL_SAVE_TO_DRAFT_COMPLETE:
      return {
        ...state,
        saveDraft: action.payload?.data?.secureMailMessage,
        uploadedAttachments:
          action.payload?.data?.secureMailMessage.attachments,
        showDraftSuccessMessage: true,
        showSentSuccessMessage: false,
        isSavingDraft: false,
      };

    case secureEmailConstants.SECURE_MAIL_REPLY_COMPLETE: {
      return {
        ...state,
        uploadedAttachments:
          action.payload?.data?.secureMailMessage.attachments,
      };
    }

    case secureEmailConstants.SECURE_MAIL_DELETE_COMPLETE: {
      return {
        ...state,
        uploadedAttachments: [],
      };
    }

    case secureEmailConstants.SECURE_EMAIL_SET_DRAFT_VALUES:
      return {
        ...state,

        saveDraft: action.payload?.details,
        draftInititalValues: action.payload?.details,
        uploadedAttachments: [...action.payload?.attachments],
      };

    case secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_COMPLETE:
      return {
        ...state,
        showDraftSuccessMessage: false,
        showSentSuccessMessage: false,
        mailInitiateDetails: { ...action.payload?.data },
      };

    case secureEmailConstants.SECURE_EMAIL_SEND_INITIATE_ERROR:
      return {
        ...state,
        mailInitiateDetails: {
          ...state.mailInitiateDetails,
          otpTimerTimePeriod: action.payload?.errorResponse?.remainingTime,
          customer: action.payload?.errorResponse?.customer,
        },
      };
    case secureEmailConstants.SECURE_MAIL_RESEND_OTP_COMPLETE:
      return {
        ...state,
        showDraftSuccessMessage: false,
        showSentSuccessMessage: false,
        mailInitiateDetails: {
          ...state.mailInitiateDetails,
          ...action.payload.data,
        },
      };

    case secureEmailConstants.SECURE_EMAIL_SEND_COMPLETE:
      return {
        ...state,

        sentMailDetails: { ...action.payload?.data?.secureMailMessage },
        uploadedAttachments: [],
      };

    case secureEmailConstants.SECURE_MAIL_LIST_COMPLETE:
      return {
        ...state,
        uploadedAttachments: [],
      };

    case secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_COMPLETE:
      return {
        ...state,
        uploadedAttachments: [],
      };

    case secureEmailConstants.SECURE_MAIL_DRAFT_CLEAR:
      return {
        ...INITIAL_SECURE_MAIL_DRAFT,
      };

    case secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_REQUEST: {
      const attachment = state.uploadingAttachments.find(
        (item) => item.id === action.payload.id,
      );

      if (attachment) {
        const updatedFiles = state.uploadingAttachments.map((file) =>
          file.id === action.payload.id
            ? { ...file, uploading: true, isFailed: false }
            : file,
        );

        return {
          ...state,
          uploadingAttachments: [...updatedFiles],
        };
      }

      return {
        ...state,
        uploadingAttachments: [action.payload, ...state.uploadingAttachments],
      };
    }

    case secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_COMPLETE: {
      const updatedFiles = state.uploadingAttachments.filter(
        (file) => file.id !== action.payload.id,
      );

      return {
        ...state,
        uploadedAttachments: action.payload?.data?.secureMailAttachmentList,
        uploadingAttachments: [...updatedFiles],
      };
    }

    case secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_ERROR: {
      const attachment = state.uploadingAttachments.find(
        (item) => item.id === action.payload.id,
      );

      if (attachment) {
        const updatedFiles = state.uploadingAttachments.map((file) =>
          file.id === action.payload.id
            ? { ...file, uploading: false, isFailed: true }
            : file,
        );

        return {
          ...state,
          uploadingAttachments: [...updatedFiles],
        };
      }

      return {
        ...state,
      };
    }

    case secureEmailConstants.SECURE_MAIL_FILE_UPLOAD_REMOVE: {
      const updatedFiles = state.uploadingAttachments.filter(
        (file) => file.id !== action.payload.id,
      );

      return {
        ...state,
        uploadingAttachments: [...updatedFiles],
      };
    }

    case secureEmailConstants.SECURE_EMAIL_SEND_ERROR:
      return {
        ...state,
        sendError: true,
        showSentSuccessMessage: false,
      };

    case secureEmailConstants.SECURE_MAIL_DELETE_COMPLETE:
      return {
        ...state,
        uploadingAttachments: [],
      };
  }
  return state;
}

const INITIAL_SECURE_MAIL_LIST_STATE = {
  mailList: [],
  draftMailList: [],
  trashMailList: [],
  isEmpty: false,
};

export function secureMailListReducer(
  state = INITIAL_SECURE_MAIL_LIST_STATE,
  action,
) {
  switch (action.type) {
    case secureEmailConstants.SECURE_MAIL_LIST_COMPLETE:
      let empty = false;
      if (action.payload?.data?.secureMailList.length == 0) {
        empty = true;
      }

      if (
        action.payload?.isDeleted == secureEmailConstants.STATUS_YES &&
        action.payload.isDraft != secureEmailConstants.STATUS_YES
      ) {
        return {
          ...state,
          mailList: [],
          draftMailList: [],
          trashMailList: action.payload?.isAppend
            ? [...state.trashMailList, ...action.payload?.data?.secureMailList]
            : [...action.payload?.data?.secureMailList],
          isEmpty: empty,
        };
      }

      if (
        action.payload.isDraft == secureEmailConstants.STATUS_YES &&
        action.payload.isDeleted != secureEmailConstants.STATUS_YES
      ) {
        return {
          ...state,
          mailList: [],
          trashMailList: [],
          draftMailList: action.payload.isAppend
            ? [...state.draftMailList, ...action.payload?.data?.secureMailList]
            : [...action.payload?.data?.secureMailList],
          isEmpty: empty,
        };
      }

      if (
        action.payload.isDraft != secureEmailConstants.STATUS_YES &&
        action.payload.isDeleted != secureEmailConstants.STATUS_YES
      ) {
        return {
          ...state,
          draftMailList: [],
          trashMailList: [],
          mailList: action.payload?.isAppend
            ? [...state.mailList, ...action.payload?.data?.secureMailList]
            : [...action.payload?.data?.secureMailList],
          isEmpty: empty,
        };
      }

    case secureEmailConstants.SECURE_MAIL_LIST_ERROR:
      return {
        ...state,
        mailList: [],
      };
  }

  return state;
}

const INITIAL_SECURE_MAIL_MESSAGE_LIST_STATE = {
  secureMailMessageList: [],

  secureMailMessage: {},
  secureMail: {},
};

export function secureMailMessageListReducer(
  state = INITIAL_SECURE_MAIL_MESSAGE_LIST_STATE,
  action,
) {
  switch (action.type) {
    case secureEmailConstants.SECURE_MAIL_MESSAGE_LIST_COMPLETE:
      return {
        ...state,

        secureMailMessageList: action.payload?.data?.secureMailMessageList,
        secureMailMessage: action.payload?.data?.secureMailMessage,
        secureMail: action.payload?.data?.secureMail,
      };

    case secureEmailConstants.SECURE_MAIL_CLEAR_MESSAGE_LIST:
      return {
        ...INITIAL_SECURE_MAIL_MESSAGE_LIST_STATE,
      };

    case secureEmailConstants.SECURE_MAIL_REPLY_COMPLETE: {
      return {
        ...state,
        ...action.payload?.data,
      };
    }

    case secureEmailConstants.SECURE_EMAIL_SEND_COMPLETE: {
      return {
        ...state,
        secureMailMessage: {},
      };
    }

    case secureEmailConstants.SECURE_MAIL_REPLY_ERROR: {
      return {
        ...state,
      };
    }
  }
  return state;
}
